<template lang="pug">
	section#texto
		.mensagem.mensagemPos(v-if="tipo == 'pos'")
			h2 PÓS-GRADUAÇÃO ONLINE
			p
				| ATENÇÃO Sr(a) Candidato(a): A Pós-Graduação UniFAEL é totalmente online. Portanto, você pode
				| estudar quando e onde quiser. O suporte ao aluno é realizado através do Ambiente Virtual de
				| Aprendizagem Sala de Aula, por onde o aluno pode sanar suas dúvidas. O aluno ainda pode
				| utilizar os outros canais de contato com a UniFAEL, como a Conecta, nossa assistente virtual,
				| o Portal do Aluno e o serviço de 0800 gratuito para alunos UniFAEL.
			p
				| Para tirar dúvidas ou apoio na realização da sua Matrícula ligue
				a(href='tel:08006426002') 0800 642 6002
			p
				a(href='https://faelpartner.force.com/centralatendimentofael/s/inscricao') INSCREVA-SE AGORA
		.mensagem.mensagemGrad(v-if="tipo == 'grad'")
			h2 Você fez uma excelente escolha!
			p
				| A UniFAEL é o centro Universitário que mais cresce no Brasil e a única que tem um compromisso com
				| a sua aprendizagem.
			p
				| Comece agora mesmo a sua busca por um Polo UniFAEL, selecionando abaixo um Estado de Interesse
				| e, na e sequência, escolha a Cidade em que deseja estudar. Pronto.
			p
				| Se não tiver um polo na sua cidade, não se preocupe, procure no mapa a unidade UniFAEL mais
				| próxima de você. Para uma perfeita navegação no mapa, basta dar um zoom para melhor
				| visualização.
			h2 Estamos esperando por você!
</template>

<script>
export default {
	name: "section-texto",
	props: {
		tipo: {
			type: [String, null],
			default: null
		},
	},
}
</script>

<style lang="stylus" scoped src="./Texto.styl"></style>
